import { ReactNode } from 'react'
import { numberFormatter } from '@/lib/formatter'

type CountViewProps = {
  icon: ReactNode
  count: number
}

export default function CountView({ count, icon }: CountViewProps) {
  return (
    <div className="flex items-center justify-between">
      <span className="flex size-3">{icon}</span>
      <span className="ml-[6px] flex">{numberFormatter(count)}</span>
    </div>
  )
}
